interface Props {
  number: string;
  className?: string;
}

const TableSeatingIcon = ({ number, className = "" }: Props) => {
  return (
    <svg viewBox="0 0 60 60" className={className} fill="none" xmlns="http://www.w3.org/2000/svg">
      {/* top chair */}
      <rect x="22" y="2" width="16" height="6" rx="2" fill="#F15A29" />
      <rect x="24" y="8" width="12" height="4" fill="#F15A29" />
      {/* bottom chair */}
      <rect x="22" y="52" width="16" height="6" rx="2" fill="#F15A29" />
      <rect x="24" y="48" width="12" height="4" fill="#F15A29" />
      {/* left chair */}
      <rect x="2" y="22" width="6" height="16" rx="2" fill="#F15A29" />
      <rect x="8" y="24" width="4" height="12" fill="#F15A29" />
      {/* right chair */}
      <rect x="52" y="22" width="6" height="16" rx="2" fill="#F15A29" />
      <rect x="48" y="24" width="4" height="12" fill="#F15A29" />
      {/* table (center) */}
      <rect x="18" y="18" width="25" height="25" rx="4" fill="#111111" />
      <text
        x="30"
        y="34"
        textAnchor="middle"
        fontFamily="Sansation, sans-serif"
        fontWeight="700"
        fontSize="9"
        fill="#FFFFFF"
        lengthAdjust="spacingAndGlyphs"
      // textLength="24"
      >
        {number}
      </text>
    </svg>
  );
};

export default TableSeatingIcon;
